module.exports = __webpack_public_path__ + "static/media/calendar.3f9c6c19.svg";